import {store} from '../../App';
import config from '../../config';

let axios   = require('axios'),
    io      = require('../io/index').actions,
    i18n    = require('i18next');

export const actiontypes = {
  TRACK_DELETE_SUCCESS: 'TRACK_DELETE_SUCCESS',
}
export const actions = {
  deleteTrack: (track) => {
    return dispatch => {
      dispatch(io.loading());
      let messages = i18n.t('io', {returnObjects: true}).tracks.track.delete;

      axios.delete(`${config.API_ADDRESS}/track/${track._id}`, {
        headers: {
          'Authorization': `Bearer ${store.getState().session.token}`
        }
      })
      .then(res => res.data)
      .then(json => {
        dispatch(trackDeleteSuccess(json));
        dispatch(io.message(messages.success,'success', false));
      })
      .catch(err => dispatch(io.message(`${messages.error} (${err.message})`, 'error', false)));
    }
  }
}


function trackDeleteSuccess(track) {
  return {
    type: actiontypes.TRACK_DELETE_SUCCESS,
    track
  }
}



// WEBPACK FOOTER //
// ./src/actions/tracks/delete.js